import { useTranslation } from "i18n";

const ReinstateOriginalPlanModalContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <p className="my-[20px] text-[18px] font-normal leading-[23px]">
        <strong>
          {t(
            "performer:accountSettings.mySubscriptionPage.reinstateOriginalPlanModal.description"
          )}
        </strong>
      </p>
      <p className="my-[20px]">
        {t(
          "performer:accountSettings.mySubscriptionPage.reinstateOriginalPlanModal.content"
        )}
      </p>
    </>
  );
};

export default ReinstateOriginalPlanModalContent;
